import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../../../styles/Auth/profile.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { getData, putData } from '../../../webService/webservice.js'
const ChangepasswordPage = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [formData, setFormData] = useState(
        {
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
        }
    );
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const userId = sessionStorage.getItem("userId");
                const response = await getData(`users/user/${userId}`, token);
            } catch (err) {
                console.error("Failed to fetch user details:", err);
            }
        };

        fetchUser();
    }, []);
    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token");
            const userId = sessionStorage.getItem("userId");
            if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
                setPasswordMatchError("All fields are required");
                return;
            }
            if (formData.newPassword !== formData.confirmPassword) {
                setPasswordMatchError("New password and confirm password do not match");
                return;
            }
            const payload = {
                currentPassword: formData.currentPassword,
                password: formData.newPassword,
            };

            const response = await putData(`users/user/${userId}`, payload, token);

            toast.success(response.message || 'Employee updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                currentPassword: "",
                newPassword: "",
                confirmPassword: "",
            });
            navigate('/dashboard');
        } catch (err) {
            console.error("Error updating profile:", err);
            alert("Failed to update profile");
        }
    };
    return (

        <>
            <div className="profile-layout">
                <div className="profile-content">
                    <main className="profile-main">
                        <div className="update-profile-form">
                            <h3>Change Password</h3>
                            <form className='profile-form'>
                                <div className='profile-form-row'>
                                    <div className="profile-form-group">
                                        <label htmlFor="currentPassword" className="input-label">
                                            Current Password
                                        </label>
                                        <div className="password-input-container">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                id="currentPassword"
                                                className="profile-input"
                                                placeholder="Enter Current Password"
                                                value={formData.currentPassword}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, currentPassword: e.target.value }))
                                                }
                                            />
                                            <span
                                                className="signup-show"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='profile-form-group'>
                                        <label htmlFor="email" className="input-label">
                                            New Password
                                        </label>
                                        <div className='password-input-container'>
                                            <input
                                                type="password"
                                                className="profile-input"
                                                placeholder="Enter New Password"
                                                value={formData.newPassword}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, newPassword: e.target.value }))
                                                }
                                            />
                                            <span
                                                className="signup-show"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="profile-form-group">
                                        <label className="input-label">Confirm Password</label>
                                        <div className='password-input-container'>
                                            <input
                                                type={showConfirmPassword ? "text" : "password"}
                                                className="profile-input"
                                                placeholder="Confirm New Password"
                                                value={formData.confirmPassword}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, confirmPassword: e.target.value }))
                                                }
                                            />
                                            <span className="signup-show" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>

                                            {passwordMatchError && <p className="password-error-text">{passwordMatchError}</p>}
                                        </div>

                                    </div>
                                </div>

                                {passwordMatchError && <p style={{ color: "red" }}>{passwordMatchError}</p>}
                                <div className="Profile-buttons">
                                    <button className="update-profile-button" type="submit" onClick={handleUpdateProfile}>
                                        Save Changes
                                    </button>
                                    <button className="cancel-Profile-button" onClick={() => navigate('/dashboard')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </main>
                </div >
            </div >
        </>
    );
};

export default ChangepasswordPage;